export enum TipoInputEnum
{
  Label = 1,
  MaterialDesign,
  Filled,
  Outlinned,
}

export enum AlineacionImagenEnum
{
  ScaleToFill = 0,
  ScaleAspectToFit,
  ScaleApectToFill,
  Top,
  Bottom
}

export enum CargaContenidoEnum
{
  Cargando = 1,
  Error,
  Finalizado,
}
